{
  "dateFormat": "MM/dd/yyyy",
  "accessType": {
    "days_one": "{{count}} day",
    "days_zero": "{{count}} days",
    "days_other": "{{count}} days",
    "byDays": "By days",
    "until": "Until {{date}}",
    "untilDate": "Until a date",
    "lifetime": "Lifetime"
  },
  "enrollmentStatus": {
    "active": "Active",
    "expired": "Expired",
    "cancelled": "Cancelled",
    "pending": "Pending",
    "paused": "Paused"
  },
  "gateways": {
    "guru": {
      "hint": "Paste this URL under Settings → Webhooks in the Guru dashboard."
    },
    "xtreed": {
      "hint": "In Xtreed, open the product → Events, create a POST event with this URL, add the header above and select order_paid, order_refunded, order_chargeback and subscription_expired. The external ID is the offer ID (the code shown in the checkout link)."
    },
    "hotmart": {
      "hint": "In Hotmart, go to Tools → Webhook, register this URL (token included) and select Purchase approved, Refund, Chargeback and Subscription cancellation. The external ID can be the product ID or the offer code."
    }
  },
  "copyableField": {
    "copy": "Copy",
    "copied": "Copied"
  },
  "list": {
    "title": "Access Groups",
    "subtitle": "Control which courses each group of students can access",
    "newGroup": "New Group",
    "searchPlaceholder": "Search groups...",
    "columns": {
      "title": "Title",
      "members": "Members",
      "access": "Access",
      "products": "Products",
      "integrations": "Integrations"
    },
    "inactive": "Inactive",
    "actions": {
      "edit": "Edit",
      "duplicate": "Duplicate",
      "delete": "Delete"
    },
    "deleteConfirm": {
      "title": "Delete access group",
      "description": "Are you sure you want to delete this access group?",
      "confirm": "Delete"
    },
    "toast": {
      "deleted": "Group deleted",
      "deleteError": "Error deleting group",
      "duplicated": "Group duplicated",
      "duplicateError": "Error duplicating group"
    },
    "empty": {
      "title": "No groups found",
      "searchHint": "Try a different search",
      "createHint": "Start by creating your first access group",
      "create": "Create Group"
    },
    "pagination": {
      "summary_one": "Page {{page}} of {{totalPages}} ({{count}} group)",
      "summary_zero": "Page {{page}} of {{totalPages}} ({{count}} groups)",
      "summary_other": "Page {{page}} of {{totalPages}} ({{count}} groups)",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "createDialog": {
    "title": "Create access group",
    "tabs": {
      "info": "Information",
      "products": "Products",
      "integrations": "Integrations",
      "members": "Members"
    },
    "sections": {
      "general": {
        "title": "General information",
        "description": "Enter the general details of your access group. This information is essential for identifying it in the admin area."
      },
      "accessTime": {
        "title": "Access time",
        "description": "Defines how long members will have to interact with the products registered in this access group."
      },
      "terms": {
        "title": "Terms of use",
        "description": "Set up the terms of use document you want to apply to this access group."
      }
    },
    "accessOptions": {
      "days": {
        "title": "Set period",
        "description": "The member will have access to the products for the set period."
      },
      "lifetime": {
        "title": "Lifetime",
        "description": "The member will have lifetime access to the products."
      },
      "date": {
        "title": "Fixed expiration",
        "description": "The member will have access to the products until the specified date."
      }
    },
    "fields": {
      "title": "Group title *",
      "titlePlaceholder": "E.g. Complete Bundle",
      "description": "Description *",
      "descriptionPlaceholder": "Describe what's included in this group...",
      "duration": "Duration (days) *",
      "durationPlaceholder": "E.g. 365",
      "expirationDate": "Expiration date *",
      "termsTitle": "Terms of use title",
      "termsTitlePlaceholder": "E.g. Xtreed Terms of Use",
      "fileUploaded": "File uploaded",
      "setTerms": "Set terms of use"
    },
    "validation": {
      "titleMin": "Title must be at least 3 characters",
      "descriptionRequired": "Description is required",
      "descriptionMax": "Maximum of 255 characters",
      "durationRequired": "Enter the duration in days",
      "expirationRequired": "Enter the expiration date"
    },
    "locked": {
      "products": "Save the information to manage the group's products.",
      "integrations": "Save the information to set up integrations.",
      "members": "Save the information to manage members."
    },
    "toast": {
      "fileUploaded": "File uploaded",
      "fileUploadError": "Error uploading file",
      "created": "Access group created",
      "createError": "Error creating group"
    },
    "cancel": "Cancel",
    "saving": "Saving...",
    "save": "Save"
  },
  "formDialog": {
    "titleEdit": "Edit Access Group",
    "titleNew": "New Access Group",
    "descriptionEdit": "Edit the access group's information",
    "descriptionNew": "Create a new group to organize products and enrollments",
    "fields": {
      "title": "Title *",
      "titlePlaceholder": "E.g. Complete Bundle",
      "description": "Description",
      "descriptionPlaceholder": "Describe what's included in this group...",
      "accessType": "Access Type",
      "accessTypePlaceholder": "Select the access type",
      "lifetime": "Lifetime",
      "byDays": "By days",
      "untilDate": "Until a date",
      "duration": "Duration (days) *",
      "durationPlaceholder": "E.g. 365",
      "expirationDate": "Expiration Date *",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "terms": "Terms of use",
      "termsTitlePlaceholder": "Terms of use title",
      "currentFile": "Current file",
      "setTerms": "Set terms of use"
    },
    "validation": {
      "titleMin": "Title must be at least 3 characters"
    },
    "toast": {
      "fileUploaded": "File uploaded",
      "fileUploadError": "Error uploading file"
    },
    "saveError": "Error saving group",
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveChanges": "Save Changes",
    "create": "Create Group"
  },
  "integrationDialog": {
    "titleEdit": "Edit integration",
    "titleNew": "New integration",
    "description": "Connect a payment platform to this group.",
    "fields": {
      "name": "Name *",
      "namePlaceholder": "E.g. Complete Bundle Checkout — Guru",
      "gateway": "Platform",
      "select": "Select",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "externalId": "External ID (gateway) *",
      "externalIdPlaceholder": "Offer/product ID in {{gateway}}",
      "externalIdHelp": "This ID is how the webhook identifies the payment and enrolls the student in this group.",
      "price": "Price shown to students",
      "priceHelp": "Shown on the buy button of the locked course. Leave blank to hide the price.",
      "currency": "Currency"
    },
    "webhookTitle": "{{gateway}} webhook",
    "validation": {
      "nameMin": "Name must be at least 2 characters",
      "externalIdRequired": "External ID is required",
      "price": "Use a value like 97 or 97.90"
    },
    "toast": {
      "updated": "Integration updated",
      "created": "Integration created",
      "saveError": "Error saving integration"
    },
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveChanges": "Save changes",
    "create": "Create integration",
    "secret": {
      "urlLabel": "Webhook URL",
      "headerLabel": "Header name",
      "tokenLabel": "Header value (token)",
      "headerHelp": "Generate this school's token and send it in the webhook header. It is what identifies your members area.",
      "queryHelp": "Generate this school's token. It goes in the URL itself because Hotmart does not allow custom headers.",
      "shownOnce": "Copy it now: the token is shown only once. Generating another one revokes the previous one.",
      "generate": "Generate token",
      "regenerate": "Generate new token",
      "error": "Could not generate the token"
    }
  },
  "productsDialog": {
    "status": {
      "published": "Published",
      "archived": "Archived",
      "draft": "Draft"
    },
    "title": "Group products",
    "description": "Select the products included in “{{title}}”.",
    "searchPlaceholder": "Search product...",
    "inGroup": "Products in group",
    "noResults": "No products found",
    "noneSelected": "No products selected yet",
    "available": "Available",
    "allInGroup": "All products are already in the group",
    "pageOf": "Page {{page}} of {{total}}",
    "previous": "Previous",
    "next": "Next",
    "pendingChanges": "{{added}} to add · {{removed}} to remove",
    "selectedCount_one": "{{count}} product in the group",
    "selectedCount_zero": "{{count}} products in the group",
    "selectedCount_other": "{{count}} products in the group",
    "toast": {
      "updated": "Products updated",
      "saveError": "Error saving products"
    },
    "cancel": "Cancel",
    "saving": "Saving...",
    "save": "Save"
  },
  "productAssignment": {
    "description": "Add, remove and reorder the courses in this section",
    "inSection": "In Section",
    "courseCount_one": "{{count}} course",
    "courseCount_zero": "{{count}} courses",
    "courseCount_other": "{{count}} courses",
    "emptyTitle": "No courses in this section",
    "emptyHint": "Add them from the list beside",
    "available": "Available",
    "searchPlaceholder": "Search courses...",
    "noResults": "No courses found",
    "allInSection": "All courses are already in this section",
    "close": "Close",
    "toast": {
      "added": "Product added to section",
      "addError": "Error adding product",
      "removed": "Product removed from section",
      "removeError": "Error removing product",
      "reorderError": "Error reordering"
    }
  },
  "detail": {
    "active": "Active",
    "inactive": "Inactive",
    "back": "Back",
    "notFound": "Access group not found",
    "backToList": "Access Groups",
    "membersCount_one": "{{count}} member",
    "membersCount_zero": "{{count}} members",
    "membersCount_other": "{{count}} members",
    "productsCount_one": "{{count}} product",
    "productsCount_zero": "{{count}} products",
    "productsCount_other": "{{count}} products",
    "tabs": {
      "info": "Information",
      "products": "Products ({{count}})",
      "integrations": "Integrations",
      "members": "Members ({{count}})"
    },
    "deleteIntegrationConfirm": {
      "title": "Delete integration",
      "description": "Are you sure you want to delete this integration?",
      "confirm": "Delete"
    },
    "toast": {
      "integrationDeleted": "Integration removed",
      "integrationDeleteError": "Error deleting integration"
    },
    "info": {
      "title": "Group information",
      "edit": "Edit",
      "fields": {
        "title": "Title",
        "status": "Status",
        "accessType": "Access type",
        "products": "Products",
        "members": "Members",
        "createdAt": "Created on",
        "updatedAt": "Updated on",
        "description": "Description",
        "terms": "Terms of use"
      },
      "noDescription": "No description",
      "termsDefault": "Terms of use",
      "viewFile": "view file",
      "notDefined": "Not set"
    },
    "products": {
      "title": "Products in group ({{count}})",
      "description": "Courses and content unlocked for members of this group.",
      "manage": "Manage",
      "published": "Published",
      "draft": "Draft",
      "empty": "No products in this group yet",
      "add": "Add products"
    },
    "integrations": {
      "title": "Configured integrations",
      "description": "Checkouts linked to this group, identified by their external ID.",
      "new": "New integration",
      "noExternalId": "No external ID",
      "edit": "Edit",
      "delete": "Delete",
      "empty": "No integrations linked to this group yet"
    },
    "members": {
      "title": "Members ({{count}})",
      "description": "Students enrolled via purchase or manually.",
      "enroll": "Enroll",
      "searchPlaceholder": "Search by name, email or CPF...",
      "statusPlaceholder": "Status",
      "allStatuses": "All statuses",
      "columns": {
        "member": "Member",
        "progress": "Progress",
        "joined": "Joined",
        "expiration": "Expiration",
        "status": "Status"
      },
      "pagination": {
        "summary_one": "Page {{page}} of {{totalPages}} ({{count}} member)",
        "summary_zero": "Page {{page}} of {{totalPages}} ({{count}} members)",
        "summary_other": "Page {{page}} of {{totalPages}} ({{count}} members)",
        "previous": "Previous",
        "next": "Next"
      },
      "emptyFiltered": "No members found with these filters",
      "empty": "No members enrolled yet",
      "enrollUser": "Enroll user"
    }
  }
}
